import {
    addExpertisesLUT,
    deleteLutExpertisesByID,
    getExpertisesDetailByID,
    getExpertisesLUT as getLUT,
    searchExpertisesLUT as searchLUT,
    updateExpertisesLUT,
} from '../../../services/lookup/lookupServiceURL'
import useCallApi from '../../../utilities/axios'

const useExpertises = () => {
    const callApi = useCallApi()

    const getExpertisesLUT = async () => {
        const response = await callApi.axiosGet({
            url: getLUT,
        })
        return response?.data
    }

    const searchExpertisesLUT = async (keyword: string | null) => {
        const response = await callApi.axiosPost({
            url: searchLUT,
            params: {
                keyword,
            },
        })
        return response?.data
    }

    const getExpertiseByID = async (expertiseID: number) => {
        const response = await callApi.axiosGet({
            url: `${getExpertisesDetailByID}/${expertiseID}`,
        })
        return response?.data
    }

    const deleteExpertiseByID = async (expertiseID: number) => {
        const response = await callApi.axiosDelete({
            url: `${deleteLutExpertisesByID}/${expertiseID}`,
        })
        return response?.data
    }

    const updateExpertiseLUT = async (expertiseID: number, nameTH: string, nameEN: string) => {
        const response = await callApi.axiosPut({
            url: updateExpertisesLUT,
            params: {
                expertiseID,
                nameTH,
                nameEN,
            },
        })
        return response?.data
    }

    const addExpertiseLUT = async (nameTH: string, nameEN: string) => {
        const response = await callApi.axiosPost({
            url: addExpertisesLUT,
            params: {
                nameTH,
                nameEN,
            },
        })
        return response?.data
    }

    return {
        getExpertisesLUT,
        searchExpertisesLUT,
        getExpertiseByID,
        deleteExpertiseByID,
        updateExpertiseLUT,
        addExpertiseLUT,
    }
}

export default useExpertises
